import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetAllCardBrandDef = () => get(url.CARD_BRAND_DEF_GET)